/**
 * @file ForgotPasswordForm.jsx
 * @author Rishikesh
 * @date 2024-10-03
 * @description Component manages the inputs and button / like form in Forgot Password page.
 */
import {
  Alert,
  Box,
  Button,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { emailRegex } from "../../../components/constants/regex";

export const ForgotPasswordForm = ({ onSubmit, successMsg }) => {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm();

  return (
    <Box
      component="form"
      maxWidth={400}
      width="100%"
      onSubmit={handleSubmit((data) => onSubmit(data, setError))}
    >
      <Stack spacing={3}>
        <Box
          border={`1px solid ${successMsg !== "" ? "green" : "#FA8232"}`}
          p={2}
          borderRadius={4}
        >
          {successMsg !== "" ? (
            <Typography color="success">{successMsg}</Typography>
          ) : (
            <Typography color="secondary.main" variant="body2">
              Enter your email and we will sent you a link to reset your
              password.
            </Typography>
          )}
        </Box>
        <TextField
          name="email"
          label="Email"
          sx={{ bgcolor: "white" }}
          fullWidth
          {...register("email", {
            required: "Email is required",
            pattern: {
              value: emailRegex,
              message: "Invalid email address",
            },
          })}
          error={!!errors.email}
          helperText={errors.email ? errors.email.message : ""}
        />

        {errors.root && <Alert severity="error">{errors.root.message}</Alert>}

        <Button
          type="submit"
          size="large"
          variant="contained"
          disabled={isSubmitting || successMsg !== ""}
          color="success"
        >
          Submit
        </Button>
      </Stack>
    </Box>
  );
};
